module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<span class="image-tags-label">\n    Tags:&nbsp;\n</span>\n';
 if (editable) { ;
__p += '\n    <div class="tag-input-container">\n        <form class="image-tag-new-form">\n            <div class="form-group">\n                <input type="text" class="tag-input" placeholder="New tag name" maxlength="' +
__e( maxNameLength ) +
'" />\n                <span class="tag-input-message"></span>\n            </div>\n        </form>\n    </div>\n';
 } ;
__p += '\n<ul class="tags-list"></ul>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/assets/image/tags/ImageTagCompositeView.tpl
// module id = 1734
// module chunks = 0